module.exports = "/src/views/player/help/images/electric.jpg";